export default __webpack_public_path__ + "static/media/info-icon.03b825cd.svg";